// --- React
import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

/**
 * CopyButton Component
 *
 * A small button that copies a value to the clipboard.
 * Shows a checkmark briefly after successful copy.
 *
 * @param {string} value - The value to copy to clipboard
 * @param {string} className - Optional additional CSS class
 */
export const CopyButton = ({ value, className = '' }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = useCallback(async (e) => {
        e.stopPropagation();
        if (!value) return;

        try {
            await navigator.clipboard.writeText(String(value));
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    }, [value]);

    if (!value) return null;

    return (
        <button
            type="button"
            className={`copy-btn ${className}`}
            onClick={handleCopy}
            title={copied ? 'Copied!' : 'Copy to clipboard'}
        >
            <i className={`fa-solid ${copied ? 'fa-check' : 'fa-copy'}`} />
        </button>
    );
};

CopyButton.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
};

export default CopyButton;
